import {
  DOWNLOAD_RESIDENTIAL_PROFILE,
  RESET_RESIDENTIAL_PROFILE,
} from "../../actionTypes/actionsTypes";
import { ActionPayload, AppAction, BaseAsyncReducerState } from "../../types";

export interface ResidentialProfileState extends BaseAsyncReducerState {
  pdf?: string;
  html?: string;
  roll?: string;
  found?: boolean;
  is_link?: boolean
}

// Define an initial state value for the app
const initialState: ResidentialProfileState = {
  pdf: undefined,
  html: undefined,
  roll: undefined,
  found: undefined,
  is_link: undefined,
  loading: false,
  error: false,
};

function downloadPdfReducer(state = initialState, action: AppAction) {
  const { payload } = action;

  switch (action.type) {
    case DOWNLOAD_RESIDENTIAL_PROFILE.PENDING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case DOWNLOAD_RESIDENTIAL_PROFILE.SUCCESS:
      return {
        ...state,
        ...(payload as ActionPayload),
        loading: false,
        error: false,
      };

    case DOWNLOAD_RESIDENTIAL_PROFILE.ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case RESET_RESIDENTIAL_PROFILE:
      return initialState;

    default:
      // If the reducer doesn't care about this action type,
      // return the existing state unchanged
      return state;
  }
}

export default downloadPdfReducer;
